import loginReducer from "./login";
import objectStoreReducer from "./objectStore";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  loginR: loginReducer,
  objectStoreR: objectStoreReducer,
});

export default rootReducer;
